import { ApiBase } from 'api/api'
import { makeGetRequest } from 'api/fetchCalls'

import { FormMeasuresResponseModel } from '@/domain/model/measures'

export const loadFormMeasures =
  async (): Promise<FormMeasuresResponseModel> => {
    const response = await makeGetRequest(ApiBase + '/forms/with_pdf', {
      params: { measures_enabled: true },
    })

    return response
  }
